/* eslint eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Button, Modal } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import '../../../../Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css';
// import CustomTable from './SortSelectTable';
import classnames from 'classnames';
import { makeGetCall,DeleteTenants, setUserID, setUserIDs,Getlicense, GetAllTenantList } from '../../../../action/tenantAction';
import SearchInput, { createFilter } from 'react-search-input';
import DeleteConfirmation from './_ModalsForms/DeleteConfirmation';
// import SearchAndSort from '../../../../Resources/SearchAndSort';
import SelectAllCheckboxes from '../../../../Resources/SelectAllCheckboxes';
import ErrorGif from '../../../../Assets/images/Error.gif';
import * as ErrorMessage from '../../../../Resources/ErrorMessages';
// import Conversions from '../../../../Resources/Conversions';
import { SaveComapnyDetailsforclient,SaveAfterHoursDetailsforclient,SaveZonesDetailsforclient,SaveEmployeeDetailsforclient,SaveMeterDetailsforClient,SaveNormalHoursDetailsforclient,SaveFixedChargesforclient } from '../../../../action/manageTenantAction';
import { DownloadSelectedInvoice } from '../../../../action/invoiceAction';
import LoadingIndicator from '../../Common/LoadingIndicator';
const KEYS_TO_FILTERS = ['tenantName', 'contactPhone', 'buildingName', 'lastInvoice', 'lastInvoiceDate'];

class Tenants extends Component {    
    componentWillMount() {
        this.props.Getlicense();
        this.props.GetAllTenantList();
        this.props.makeGetCall().then(() => {this.setState({isloading:false})} );
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps && nextProps.getResponse != undefined) {
            this.setState({ tenants_Data_in_state: nextProps.getResponse });
            if(nextProps.getResponse == null || nextProps.getResponse.length <= 0)
                this.setState({No_Records_Found:true});
        }
        else{
            this.setState({No_Records_Found:true});
        }       
    }

    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            redirect: false,
            modal: false,
            deletemodal: false,
            error_msg: false,
            selected_Check_Boxes: [],
            tenantID: '',
            createNewTenantRedirect: false,
            searchTerm: '',
            sort: {
                column: null,
                direction:[
                    {name:'tenantName', direction:'asc', onclick:true},
                    {name:'contactPhone', direction:'desc', onclick:false},
                    {name:'buildingName', direction:'desc', onclick:false},
                    {name:'lastInvoice', direction:'desc', onclick:false},
                    {name:'lastInvoiceDate', direction:'desc', onclick:false},
                ]
            },
            IsDefaultSort: true,
            tenants_Data_in_state: null,
            PrepareInvoiceRedirect: false,
            No_Records_Found: false
        };
        this.handleClick = this.handleClick.bind(this);
        this.CreateNewTenant = this.CreateNewTenant.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this);
        this.Deletetoggle = this.Deletetoggle.bind(this);
        this.deleteTenants = this.deleteTenants.bind(this);
        this.PrepareInvoice = this.PrepareInvoice.bind(this);
        this.downloadInvoice = this.downloadInvoice.bind(this);
    }
    
    handleClick() {
        this.setState({
            redirect: true
        });
    }

    CreateNewTenant() {
        this.props.SaveComapnyDetailsforclient(undefined);
        this.props.SaveAfterHoursDetailsforclient(undefined);
        this.props.SaveZonesDetailsforclient(undefined);
        this.props.SaveEmployeeDetailsforclient(undefined);
        this.props.SaveMeterDetailsforClient(undefined);
        this.props.SaveNormalHoursDetailsforclient(undefined);
        this.props.SaveFixedChargesforclient(undefined);
        this.setState({
            createNewTenantRedirect: true
        });
    }

    ViewtenantDetailslink(tenantId) {
        this.props.setUserID(tenantId);
        this.setState({
            redirect: true,
            tenantID: tenantId,
        });
    }

    /* Common function */

    IsAnyCheckboxChecked = () => {
        var IsAnyChecked = false;
        var checkboxes = document.getElementsByClassName('TenantRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                IsAnyChecked = true;
            }
        }
        return IsAnyChecked;
    }

    /* Prepare Invoice */

    PrepareInvoice(){
        this.setState({ error_msg: false });
        if(this.IsAnyCheckboxChecked())
        {
            var Data = {tenantIds:[]};
            var checkboxes = document.getElementsByClassName('TenantRows');
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked === true) {
                    var tenant_id_for_prepare_invoice = checkboxes[i].id;
                    Data.tenantIds.push(tenant_id_for_prepare_invoice);
                }
            }

            this.props.setUserIDs(Data);

            this.setState({
                PrepareInvoiceRedirect: true
            });
        }
        else
        {
            this.setState({ error_msg: true });
        }
    }

    /* Delete System */


    Deletetoggle() {
        this.setState({
            deletemodal: !this.state.deletemodal
        });
    }

    deleteTenants() {
        this.setState({ error_msg: false });
        var IsAnyChecked = false;
        var checkboxes = document.getElementsByClassName('TenantRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                IsAnyChecked = true;
            }
        }
        if (IsAnyChecked) this.Deletetoggle();
        else this.setState({ error_msg: true });
    }

    /* Delete Confirmation*/

    Delete = (someArg) => {
        if (someArg == "yes") {
            var Data = [];
            var checkboxes = document.getElementsByClassName('TenantRows');
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked === true) {
                    var tenant_id_to_be_deleted = {
                        "tenantId": checkboxes[i].id
                    }
                    Data.push(tenant_id_to_be_deleted);
                }
            }

            if (Data.length > 0) {
                this.setState({ error_msg: false });
                 this.props.DeleteTenants(Data);
                this.Deletetoggle();
            }
        }
        else {
            this.Deletetoggle();
        }
    }


    /* Filter System */

    searchUpdated(term) {
        this.setState({ searchTerm: term })
    }

    downloadInvoice(invoiceId,fileName){
        if(fileName != "" && fileName != undefined ){
        var fileArray = fileName.split('.');
        console.log(fileArray[0] +", "+ fileArray[1]);
        this.props.DownloadSelectedInvoice(invoiceId,fileArray[0],"."+fileArray[1]);
        }
    }

    /* Sorting  System */

    onSort = (column) => (e) => {
        this.setState({IsDefaultSort: false});
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.state.tenants_Data_in_state;
        var notequals = 0;

       if(data_from_state != null){
        const sortedData = this.state.tenants_Data_in_state.sort((a, b) => {
            const nameA = a[column].toLowerCase();
            const nameB = b[column].toLowerCase();
            if (nameA < nameB) {
                notequals = 1;
                return -1;
            }
            if (nameA > nameB) {
                notequals = 1;
                return 1;
            }
            if (nameA == nameB) {
                return 0;
            }
            return 0;
        });

        if(selected[0].direction =='asc' && notequals == 1){
        sortedData.reverse();
     }

      SortData.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
      SortData.map(x => (x.name !== column) ? x.direction = SortData.filter(m => (m.name === x.name))[0].direction : x.direction = direction);

        this.setState({
            tenants_Data_in_state: sortedData,
            sort: {
                column,
                direction : SortData,
            }
        })
       }
    };


    setArrow = (column) => {
        let className = 'workorder-sort-direction';
        // if (this.state.sort.column === column) {
        //     className += this.state.sort.direction === 'asc' ? ' asccolor' : ' desccolor';
        // }
        let sortColumn = this.state.sort.direction.filter(x => (x.name === column))[0];
        className += (sortColumn.onclick === true) ? (sortColumn.direction === 'asc') ? ' asccolor' : ' desccolor' : ' desc';
        return className;
    };


    render(getLabels,getResponse,getLicense,UserCanEdit) {
        let lcount = 0, lUserCanEdit, IsMaximumExists = false;
        let label = this.props.getLabels;
        // let license_count = this.props.getResponse;
        // if(license_count !== undefined && license_count !== null){
        //     lcount = license_count.length;
        // }
        
        lUserCanEdit = this.props.UserCanEdit;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;
        
        if (this.state.redirect) {
            return <Redirect to={{ pathname: '/ViewIndividualTenantManage' }} />
        }

        if (this.state.createNewTenantRedirect) {
            return <Redirect to={"/managetenant/CreateTenant"} />
        }

        if (this.state.PrepareInvoiceRedirect) {
            return <Redirect to={"/Invoices/prepareinvoices"} />
        }

        let Tenants, data, FilteredData, Error_Message = null;

        data = this.state.tenants_Data_in_state;

        if (data != undefined && data.length > 0 && data != null && !this.state.isloading) {
            if(this.state.IsDefaultSort){
                data.sort((a,b)=>{
                    let nameA = a['tenantName'].toLowerCase();
                    let nameB = b['tenantName'].toLowerCase();
                    if(nameA < nameB){
                        return -1;
                    }
                    if(nameA > nameB){
                        return 1;
                    }
                    if(nameA == nameB){
                        return 0;
                    }
                    return 0;
                });
            }
            data = data.filter(el => el.isWorkOrder !== true);
            FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            lcount = data.length;
            if (FilteredData.length != 0) {
                Tenants = FilteredData.map(el => (
                    <tr key={el.tenantId}>
                        <td  width="5%"><input type="checkbox"  id={el.tenantId} className="TenantRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("TenantRows", "header_Check_box"); }} /></td>
                        <td  width="20%"><p className="link_cursor"  style={{ color: '#6890C6' }} onClick={() => { this.ViewtenantDetailslink(el.tenantId) }} >{el.tenantName}</p></td>
                        <td  width="20%">{el.contactPhone}</td>
                        <td  width="25%">{el.buildingName}</td>
                        <td  width="15%">{new Date(el.lastInvoiceDate) > new Date("01/01/0001") ? new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(el.lastInvoiceDate).setHours(0,0,0,0)) : ""}</td>
                        <td  width="15%"><label style={{ color: '#6890C6' }} onClick={() => {this.downloadInvoice(el.lastInvoiceId,el.tenantName+"_"+el.lastInvoice)}}  className="link_cursor">{el.lastInvoice != "" ? el.lastInvoice.split('.')[0] : el.lastInvoice }</label></td>
                    </tr>
                ));
            }
            else {
                Tenants = <tr><td colSpan="6">{label['NoRecords.Text']}</td></tr>
            }
        }
        else {
            if(this.state.No_Records_Found == true && !this.state.isloading) {
               Tenants = <tr><td colSpan="6">{label['NoRecords.Text']}</td></tr>
            }
            else {
                Tenants = <tr><td colspan="6" style={{textAlign: 'center'}}><LoadingIndicator/></td></tr>
            }
        }

        let license = this.props.getLicense;
        if(lcount !== undefined && license !== undefined && license !== null){
            if(Number(license) <= Number(lcount))
                IsMaximumExists = true;
        }
        
        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  {ErrorMessage.selection_error_alt}</p> : Error_Message = " ";

        return (
            <div className="tenant_content_border">
                <div className="main_container">
                    {Error_Message}
                    <div>
                        <p style={{fontFamily:'Verdana',fontSize:'12px'}}><b>{label['ManageTenants.LicenseHeading.Text']}</b></p>
                        <p style={{fontFamily:'Verdana',fontSize:'12px'}}>{label['ManageTenants.LicenseUsedText.Text']}  {lcount} of {license} </p>
                    </div>

                    <div className="buttons_container">
                        <Button type="button" id="btn_tenanttab_delete"  hidden={!lUserCanEdit} className="btn btn-black" onClick={this.deleteTenants} >{label['Requests.btnDelete.Text']}  </Button>
                        <Button type="button" id="btn_tenanttab_prepareinvoice" hidden={!lUserCanEdit} className="btn-success" onClick={this.PrepareInvoice} >{label['ManageTenants.BillingPreview.Text']}  </Button>
                        <Button style={{ border:"none",
 outline:"none"
}} id="btn_tenanttab_createtenant" hidden={!lUserCanEdit} disabled={IsMaximumExists} className="btn-success" onClick={() => { this.CreateNewTenant() }}  >{label['ManageTenants.CreateTenant.Text']}   </Button>
                        <SearchInput className="search-input" onChange={this.searchUpdated} />
                    </div>

                    <div className="table_container">
                        <Table striped responsive className=" Custom_table table_border">
                            <tbody className="cell_container tenant_cell">
                                <tr>
                                    <th><input type="checkbox" className="header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("TenantRows", "header_Check_box"); }} /></th>
                                    <th onClick={this.onSort('tenantName')} className="link_cursor">{label['ManageTenants.Columns.TenantName.Text']}<span className={this.setArrow('tenantName')}></span> </th>
                                    <th onClick={this.onSort('contactPhone')} className="link_cursor">{label['ManageTenants.Columns.ContactInfo.Text']}&nbsp; <span className={this.setArrow('contactPhone')}></span></th>
                                    <th onClick={this.onSort('buildingName')} className="link_cursor">{label['ManageTenants.Columns.Building.Text']} <span className={this.setArrow('buildingName')}></span></th>
                                    <th onClick={this.onSort('lastInvoiceDate')} className="link_cursor">{label['ManageTenants.Columns.LastInvoiceDate.Text']} <span className={this.setArrow('lastInvoiceDate')}></span></th>
                                    <th onClick={this.onSort('lastInvoice')} className="link_cursor">{label['ManageTenants.Columns.LastInvoice.Text']} <span className={this.setArrow('lastInvoice')}></span></th>
                                </tr>
                                {Tenants}
                            </tbody>
                        </Table>
                    </div>
                    
                    <Modal isOpen={this.state.deletemodal} deletemodal={this.deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                        <DeleteConfirmation parentToChildData={["Delete Tenant", "You are about to delete a tenant from the system. Do you want to continue?", "Close Window", "Delete Tenant"]} Delete={this.Delete} />
                    </Modal>
                </div>
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        getResponse: state.tenantsRootReducer.TenantsList,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        getLicense: state.tenantsRootReducer.licensed,
        UserCanEdit: state.authService.HasApplicationFullAcess
    };
};

const mapDispatchToProps = dispatch => {
    return {
        makeGetCall: () => dispatch(makeGetCall()),
        GetAllTenantList: () => dispatch(GetAllTenantList()),
        Getlicense : () => dispatch(Getlicense()),
        DeleteTenants: (data) => dispatch(DeleteTenants(data)),
        setUserID: (userID) => dispatch(setUserID(userID)),
        setUserIDs: (userIDs) => dispatch(setUserIDs(userIDs)),
        SaveComapnyDetailsforclient: (data) => dispatch(SaveComapnyDetailsforclient(data)),
        SaveAfterHoursDetailsforclient: (data) => dispatch(SaveAfterHoursDetailsforclient(data)),
        SaveZonesDetailsforclient: (data) => dispatch(SaveZonesDetailsforclient(data)),
        SaveEmployeeDetailsforclient: (data) => dispatch(SaveEmployeeDetailsforclient(data)),
        SaveMeterDetailsforClient: (data) => dispatch(SaveMeterDetailsforClient(data)),
        SaveNormalHoursDetailsforclient: (data) => dispatch(SaveNormalHoursDetailsforclient(data)),
        SaveFixedChargesforclient: (data) => dispatch(SaveFixedChargesforclient(data)),
        DownloadSelectedInvoice:(invoiceId,fileName,fileFormat)  => dispatch(DownloadSelectedInvoice(invoiceId,fileName,fileFormat))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tenants);
